export const UPDATE = 'survey_blocks/UPDATE';
export const SET_SELECTED = 'survey_blocks/SET_SELECTED';
export const EMPTY = "survey_blocks/EMPTY";
export const LOADING = "survey_blocks/LOADING";
